import reportingService from '@/api/clients/bingoManager-core/sessionReporting.js';

const state = {
  sessions: [],
  selectedSessionDetails: [],
  error: null,
  loading: false,
};

const mutations = {
  SET_SESSIONS(state, sessions) {
    state.sessions = sessions;
    state.error = null;
    
    if (sessions.length === 0) {
      state.selectedSessionDetails = [];
    }
  },
  SET_SESSION_DETAILS(state, details) {
    state.selectedSessionDetails = details.map(detail => ({
      ...detail,
      expanded: false,
    }));
    state.error = null;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
};

const actions = {
  async fetchSessions({ commit }, { startDate, endDate }) {
    commit('SET_LOADING', true);
    try {
      const response = await reportingService.getScheduleInRange(startDate, endDate);

      if (response.status === 200 && response.data) {
      const formattedSessions = response.data.map(session => {
  const dateObj = new Date(session.date);
  const formattedDate = dateObj.toLocaleDateString('en-CA');

  const timeParts = session.time.split(':'); // [hour, minute, second]
  const [year, month, day] = [
    dateObj.getFullYear(),
    dateObj.getMonth() + 1,
    dateObj.getDate(),
  ];

  const utcDate = new Date(Date.UTC(
    year,
    month - 1,
    day,
    parseInt(timeParts[0]),
    parseInt(timeParts[1])
  ));

  const localTime = `${String(utcDate.getHours()).padStart(2, '0')}:${String(utcDate.getMinutes()).padStart(2, '0')}`;

  return {
    ...session,
    date: formattedDate,
    time: localTime,
  };
});

        commit('SET_SESSIONS', formattedSessions);
      } else {
        commit('SET_SESSIONS', []); 
        throw new Error('Invalid response structure from server');
      }
    } catch (error) {
      console.error('Error in fetchSessions:', error);
      commit('SET_SESSIONS', []); 
      commit('SET_ERROR', error.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchSessionDetails({ commit, state }, scheduleId) {
    if (!scheduleId) {
      commit('SET_SESSION_DETAILS', []); 
      commit('SET_ERROR', 'No session selected');
      return;
    }

    commit('SET_LOADING', true);
    try {
      const session = state.sessions.find((s) => s.id === scheduleId);
      if (!session) {
        throw new Error('Selected session not found');
      }

      const sessionDate = session.date;

      const { data } = await reportingService.getReportingByScheduleId(scheduleId, sessionDate);

      if (data?.length > 0) {
        const formattedDetails = data.map(details => ({
          title: details.scheduleTitle || session.title || 'Untitled Session',
          date: session.date,
        startTime: details.startTime
  ? (() => {
      const [year, month, day] = session.date.split('-').map(Number); // get year, month, day from session date
      const [hour, minute] = details.startTime;
      const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute));
      return `${String(utcDate.getHours()).padStart(2, '0')}:${String(utcDate.getMinutes()).padStart(2, '0')}`;
    })()
  : session.time,

          gamesPlayed: `${details.numberOfGames || 0} Games`,
          pagesSold: `${details.pagesSold || 0} Pages`,
          revenue: `€${details.totalSales?.toFixed(2) || '0.00'}`,
          payouts: `€${details.totalWinnings?.toFixed(2) || '0.00'}`,
          netProfit: details.netProfit || 0,
          players: `${details.uniquePlayers || 0} Players`,
          availablePatterns: details.gamePatterns
            ?.map((p) => p.configuredPatterns?.length || 0)
            .join(', ') || '0',
          winningPatterns: details.gamePatterns?.map((p) => p.ratio || 'None').join(', ') || 'None',
          avgSpend: `€${details.averageSpendPerPlayer?.toFixed(2) || '0.00'} `,
        }));
        commit('SET_SESSION_DETAILS', formattedDetails);
      } else {
        commit('SET_SESSION_DETAILS', []); 
        throw new Error('No details found for this session');
      }
    } catch (error) {
      console.error('Error in fetchSessionDetails:', error);
      commit('SET_SESSION_DETAILS', []); 
      commit('SET_ERROR', error.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

const getters = {
  sessions: state => state.sessions,
  selectedSessionDetails: state => state.selectedSessionDetails,
  error: state => state.error,
  loading: state => state.loading,
  sessionOptions: state =>
    state.sessions.map(session => ({
      text: `${session.title} - ${session.date} ${session.time}`,
      id: session.id,
    })),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};